import styled from 'styled-components'

import theme from 'theme_'

export const ChangePassInstructionsBlock = styled.div`
  max-width: 600px;
  margin: ${theme.spacing.md} auto;
`

export const ChangePassBtnWrap = styled.div`
  display: flex;
  justify-content: center;
`

export const ChangePassModalContainer = styled.div`
  padding: 64px 0;
  text-align: center;
  display: flex;
  flex-flow: column;
  align-items: center;
`

export const ChangePassIconWrap = styled.div`
  margin: ${theme.spacing.xs} auto ${theme.spacing.xxl};
`
